import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("sp_access");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config || {};
    const url = orig.url || "";
    const skip = url.includes("/auth/login") || url.includes("/auth/refresh");
    if (err.response?.status === 401 && !orig._retry && !skip) {
      orig._retry = true;
      try {
        const { data } = await api.post("/auth/refresh", {
          refresh_token: localStorage.getItem("sp_refresh"),
        });
        localStorage.setItem("sp_access", data.access_token);
        return api(orig);
      } catch (e) {
        localStorage.removeItem("sp_access");
        localStorage.removeItem("sp_refresh");
        window.dispatchEvent(new Event("sp-logout"));
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "A apărut o eroare. Încearcă din nou.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  if (typeof detail.message === "string") return detail.message;
  return String(detail);
}
